export default {
  "API_URL": "https://cms.uiwd.co"
}

